import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Divider,
  Grid,
  TextField,
  Typography,
} from '@material-ui/core';
import ImageUploadField from '../ImageUploadField';
import {
  SEO_TITLE_MAX_LENGTH,
  META_DESCRIPTION_MAX_LENGTH,
  PRIMARY_KEYWORD_MAX_LENGTH,
  OG_TITLE_MAX_LENGTH,
} from '../../utils/const/seoLimits';

function SeoFields({
  errors,
  handleBlur,
  handleChange,
  ogImageFolder,
  setFieldValue,
  touched,
  values,
}) {
  return (
    <>
      <Grid item xs={12}>
        <Box mt={1} mb={1}>
          <Divider />
          <Typography variant="h6" style={{ marginTop: 16 }}>SEO</Typography>
        </Box>
      </Grid>
      <Grid item md={6} xs={12}>
        <TextField
          error={Boolean(touched.seoTitle && errors.seoTitle)}
          fullWidth
          helperText={(touched.seoTitle && errors.seoTitle) || `${values.seoTitle.length}/${SEO_TITLE_MAX_LENGTH} — si se deja vacío, se usa el título`}
          label="Título SEO"
          name="seoTitle"
          onBlur={handleBlur}
          onChange={handleChange}
          inputProps={{ maxLength: SEO_TITLE_MAX_LENGTH }}
          value={values.seoTitle}
          variant="outlined"
        />
      </Grid>
      <Grid item md={6} xs={12}>
        <TextField
          error={Boolean(touched.primaryKeyword && errors.primaryKeyword)}
          fullWidth
          helperText={touched.primaryKeyword && errors.primaryKeyword}
          label="Keyword principal"
          name="primaryKeyword"
          onBlur={handleBlur}
          onChange={handleChange}
          required
          inputProps={{ maxLength: PRIMARY_KEYWORD_MAX_LENGTH }}
          value={values.primaryKeyword}
          variant="outlined"
        />
      </Grid>
      <Grid item md={12} xs={12}>
        <TextField
          error={Boolean(touched.metaDescription && errors.metaDescription)}
          fullWidth
          multiline
          helperText={(touched.metaDescription && errors.metaDescription) || `${values.metaDescription.length}/${META_DESCRIPTION_MAX_LENGTH}`}
          label="Meta descripción"
          name="metaDescription"
          onBlur={handleBlur}
          onChange={handleChange}
          required
          inputProps={{ maxLength: META_DESCRIPTION_MAX_LENGTH }}
          value={values.metaDescription}
          variant="outlined"
        />
      </Grid>
      <Grid item md={12} xs={12}>
        <TextField
          fullWidth
          helperText="Hasta 5 keywords separadas por coma"
          label="Keywords secundarias"
          name="secondaryKeywords"
          onBlur={handleBlur}
          onChange={handleChange}
          value={values.secondaryKeywords}
          variant="outlined"
        />
      </Grid>
      <Grid item md={6} xs={12}>
        <TextField
          error={Boolean(touched.ogTitle && errors.ogTitle)}
          fullWidth
          helperText={(touched.ogTitle && errors.ogTitle) || 'Si se deja vacío, se usa el título SEO'}
          label="Título OG (redes sociales)"
          name="ogTitle"
          onBlur={handleBlur}
          onChange={handleChange}
          inputProps={{ maxLength: OG_TITLE_MAX_LENGTH }}
          value={values.ogTitle}
          variant="outlined"
        />
      </Grid>
      <Grid item md={6} xs={12}>
        <ImageUploadField
          folder={ogImageFolder}
          helperText="Si se deja vacía, se usa la imagen de portada"
          label="Imagen OG (redes sociales)"
          name="ogImage"
          onBlur={handleBlur}
          onChange={(url) => setFieldValue('ogImage', url)}
          value={values.ogImage}
        />
      </Grid>
    </>
  );
}

SeoFields.propTypes = {
  errors: PropTypes.object.isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  ogImageFolder: PropTypes.string.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  touched: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
};

export default SeoFields;
